import getEnv from 'get-env';

export default getEnv({
    test: 'test',
});
